import React from 'react';
import { theme } from 'codeArt/components/Base';
import { DataContext } from './context';

//在当前页面的路由表页面进行调用 否则不进行触发调用
export function importData() {
    DataContext.register([
        {
            name: "PERFORMANCE_OVERVIEW_EYE",
            data: data
        },
        {
            name: "PERFORMANCE_OVERVIEW_KEY",
            data: PERFORMANCE_OVERVIEW_KEY
        },
        {
            name: "PERFORMANCE_OVERVIEW_KEY_SCEAP_RATE_CHART",
            data: PERFORMANCE_OVERVIEW_KEY_SCEAP_RATE_CHART
        }
        ,
        {
            name: "PERFORMANCE_OVERVIEW_KEY_QUALIFYIELD_CHART",
            data: PERFORMANCE_OVERVIEW_KEY_QUALIFYIELD_CHART
        }
        ,
        {
            name: "PERFORMANCE_OVERVIEW_KEY_AVERAGETIME_CHART",
            data: PERFORMANCE_OVERVIEW_KEY_AVERAGETIME_CHART
        }
        ,
        {
            name: "PERFORMANCE_OVERVIEW_KEY_TIME_UTILIZATION_CHART",
            data: PERFORMANCE_OVERVIEW_KEY_TIME_UTILIZATION_CHART
        }
        ,
        {
            name: "PERFORMANCE_OVERVIEW_KEY_EFFECT_CHART",
            data: PERFORMANCE_OVERVIEW_KEY_EFFECT_CHART
        }
        ,
        {
            name: "PERFORMANCE_OVERVIEW_KEY_MIO_STOP_NUMBER_CHART",
            data: PERFORMANCE_OVERVIEW_KEY_MIO_STOP_NUMBER_CHART
        }
    ]);
}

const PERFORMANCE_OVERVIEW_KEY = [
    { scrapRate: 0.12, qualifYield: 31224, averageTime: "03:13:56", timeUtilization: "87.5", effect: "89", mioStopNumber: 3 },
    { scrapRate: 0.08, qualifYield: 28324, averageTime: "03:27:52", timeUtilization: "88.8", effect: "89.3", mioStopNumber: 4, },
    { scrapRate: 0.07, qualifYield: 27455, averageTime: "03:43:42", timeUtilization: "89.4", effect: "92", mioStopNumber: 5, },
    { scrapRate: 0.06, qualifYield: 32476, averageTime: "03:36:45", timeUtilization: "92.6", effect: "95", mioStopNumber: 2, },
];

const PERFORMANCE_OVERVIEW_KEY_SCEAP_RATE_CHART = [
    [0.12, 0.08, 0.07, 0.06, 0.15],
    [0.09, 0.12, 0.15, 0.08, 0.06],
    [0.10, 0.15, 0.05, 0.08, 0.09]
];

const PERFORMANCE_OVERVIEW_KEY_QUALIFYIELD_CHART = [
    [31224, 37224, 39238, 35653, 45225],
    [35226, 37224, 32348, 34656, 38242],
    [34243, 42225, 35348, 39234, 36223],
];

const PERFORMANCE_OVERVIEW_KEY_AVERAGETIME_CHART = [
    [3.5, 3.65, 3.1, 3.2, 3.4],
    [3.3, 3.4, 3.2, 3.35, 3.5],
    [3.2, 3.35, 3.6, 3.45, 3.2],
];

const PERFORMANCE_OVERVIEW_KEY_TIME_UTILIZATION_CHART = [
    [0.85, 0.89, 0.87, 0.82, 0.91],
    [0.82, 0.85, 0.86, 0.84, 0.88],
    [0.83, 0.89, 0.82, 0.85, 0.89],
];

const PERFORMANCE_OVERVIEW_KEY_EFFECT_CHART = [
    [0.85, 0.89, 0.82, 0.85, 0.87],
    [0.84, 0.85, 0.86, 0.84, 0.92],
    [0.83, 0.89, 0.87, 0.82, 0.91],
];

const PERFORMANCE_OVERVIEW_KEY_MIO_STOP_NUMBER_CHART = [
    [4, 5, 3, 4, 6],
    [2, 4, 3, 6, 3],
    [4, 5, 7, 3, 5],
];

const Suite01_Shift0 = {
    equipment: "L01",//设备
    theorOutput: "34525",//理论的产量
    qualifYield: "23423",//合格的产量
    timeUtilization: "23%",//时间利用率
    averageTime: "03:23:44",//平均无故障时间
    stopNumber: "3",//停机次数
    shiftTime: "03:22:43",//班次时间
    stoptimeIn: "00:34:00",//停机持续时间 内部
    stoptimeOut: "00:12:00",//停机持续时间外部
    effect: "87%",//效率
    scrapRate: "12%",//废品率
    scrap: "2341",//废品
}

const Suite01_Shift1 = {
    equipment: "L01",//设备
    theorOutput: "34212",//理论的产量
    qualifYield: "34123",//合格的产量
    timeUtilization: "67%",//时间利用率
    averageTime: "02:23:12",//平均无故障时间
    stopNumber: "2",//停机次数
    shiftTime: "04:34:10",//班次时间
    stoptimeIn: "00:12:00",//停机持续时间 内部
    stoptimeOut: "00:23:00",//停机持续时间外部
    effect: "43%",//效率
    scrapRate: "23%",//废品率
    scrap: "4342",//废品
    OEE: "1231",//OEE
    OEE: "60%", //OEE
    MTBF: "39:23 min", //平均无故障时间
}

const Suite02_Shift0 = {
    equipment: "L02",//设备
    theorOutput: "65431",//理论的产量
    qualifYield: "64543",//合格的产量
    timeUtilization: "34%",//时间利用率
    averageTime: "03:44:34",//平均无故障时间
    stopNumber: "2",//停机次数
    shiftTime: "03:45:10",//班次时间
    stoptimeIn: "00:45:00",//停机持续时间 内部
    stoptimeOut: "00:23:00",//停机持续时间外部
    effect: "56%",//效率
    scrapRate: "45%",//废品率
    scrap: "2345",//废品
    OEE: "5423",//OEE
    OEE: "65%", //OEE
    MTBF: "36:21 min", //平均无故障时间
}

const Suite02_Shift1 = {
    equipment: "L02",//设备
    theorOutput: "54567",//理论的产量
    qualifYield: "65453",//合格的产量
    timeUtilization: "45%",//时间利用率
    averageTime: "02:34:15",//平均无故障时间
    stopNumber: "1",//停机次数
    shiftTime: "04:43:10",//班次时间
    stoptimeIn: "00:34:00",//停机持续时间 内部
    stoptimeOut: "00:56:00",//停机持续时间外部
    effect: "34%",//效率
    scrapRate: "21%",//废品率
    scrap: "34524",//废品
    OEE: "2313",//OEE
    OEE: "55%", //OEE
    MTBF: "31:21 min", //平均无故障时间
}

const Suite03_Shift0 = {
    equipment: "L03",//设备
    theorOutput: "23455",//理论的产量
    qualifYield: "34523",//合格的产量
    timeUtilization: "55%",//时间利用率
    averageTime: "01:23:34",//平均无故障时间
    stopNumber: "3",//停机次数
    shiftTime: "04:23:32",//班次时间
    stoptimeIn: "00:45:00",//停机持续时间 内部
    stoptimeOut: "00:34:00",//停机持续时间外部
    effect: "77%",//效率
    scrapRate: "13%",//废品率
    scrap: "2345",//废品
    OEE: "4323",//OEE
    OEE: "75%", //OEE
    MTBF: "19:22 min", //平均无故障时间
}

const Suite03_Shift1 = {
    equipment: "L03",//设备
    theorOutput: "45234",//理论的产量
    qualifYield: "34543",//合格的产量
    timeUtilization: "34%",//时间利用率
    averageTime: "03:54:15",//平均无故障时间
    stopNumber: "2",//停机次数
    shiftTime: "02:24:10",//班次时间
    stoptimeIn: "00:45:00",//停机持续时间 内部
    stoptimeOut: "00:22:00",//停机持续时间外部
    effect: "98%",//效率
    scrapRate: "2%",//废品率
    scrap: "532",//OEE
    OEE: "77%", //OEE
    MTBF: "18:37 min", //平均无故障时间
}

const Suite04_Shift0 = {
    equipment: "L04",//设备
    theorOutput: "76544",//理论的产量
    qualifYield: "67554",//合格的产量
    timeUtilization: "78%",//时间利用率
    averageTime: "01:23:44",//平均无故障时间
    stopNumber: "3",//停机次数
    shiftTime: "04:34:10",//班次时间
    stoptimeIn: "00:55:00",//停机持续时间 内部
    stoptimeOut: "00:45:00",//停机持续时间外部
    effect: "82%",//效率
    scrapRate: "21%",//废品率
    scrap: "3244",//OEE
    OEE: "1012",//OEE
    OEE: "76%", //OEE
    MTBF: "19:24 min", //平均无故障时间
}

const Suite04_Shift1 = {
    equipment: "L04",//设备
    theorOutput: "54345",//理论的产量
    qualifYield: "34545",//合格的产量
    timeUtilization: "78%",//时间利用率
    averageTime: "04:14:12",//平均无故障时间
    stopNumber: "3",//停机次数
    shiftTime: "04:12:10",//班次时间
    stoptimeIn: "00:14:00",//停机持续时间 内部
    stoptimeOut: "00:34:00",//停机持续时间外部
    effect: "91%",//效率
    scrapRate: "9%",//废品率
    scrap: "2343",//OEE
    OEE: "1012",//OEE
    OEE: "66%", //OEE
    MTBF: "17:24 min", //平均无故障时间
}

const Suite05_Shift0 = {
    equipment: "L05",//设备
    theorOutput: "52341",//理论的产量
    qualifYield: "65421",//合格的产量
    timeUtilization: "85%",//时间利用率
    averageTime: "03:12:12",//平均无故障时间
    stopNumber: "1",//停机次数
    shiftTime: "05:34:10",//班次时间
    stoptimeIn: "00:11:00",//停机持续时间 内部
    stoptimeOut: "00:21:00",//停机持续时间外部
    effect: "87%",//效率
    scrapRate: "13%",//废品率
    scrap: "4343",//废品
    OEE: "1212",//OEE
    OEE: "68%", //OEE
    MTBF: "15:23 min", //平均无故障时间
}

const Suite05_Shift1 = {
    equipment: "L05",//设备
    theorOutput: "34234",//理论的产量
    qualifYield: "12322",//合格的产量
    timeUtilization: "93%",//时间利用率
    averageTime: "03:23:12",//平均无故障时间
    stopNumber: "2",//停机次数
    shiftTime: "02:12:10",//班次时间
    stoptimeIn: "00:43:00",//停机持续时间 内部
    stoptimeOut: "00:23:00",//停机持续时间外部
    effect: "89%",//效率
    scrapRate: "11%",//废品率
    scrap: "2331",//废品
    OEE: "3221",//OEE
    OEE: "78%", //OEE
    MTBF: "21:23 min", //平均无故障时间
}

const Suite06_Shift0 = {
    equipment: "L06",//设备
    theorOutput: "23341",//理论的产量
    qualifYield: "23411",//合格的产量
    timeUtilization: "89%",//时间利用率
    averageTime: "01:42:12",//平均无故障时间
    stopNumber: "4",//停机次数
    shiftTime: "05:42:10",//班次时间
    stoptimeIn: "00:52:00",//停机持续时间 内部
    stoptimeOut: "00:51:00",//停机持续时间外部
    effect: "93%",//效率
    scrapRate: "9%",//废品率
    scrap: "1233",//废品
    OEE: "3223",//OEE
    OEE: "88%", //OEE
    MTBF: "29:23 min", //平均无故障时间
}

const Suite06_Shift1 = {
    equipment: "L06",//设备
    theorOutput: "21132",//理论的产量
    qualifYield: "12344",//合格的产量
    timeUtilization: "34%",//时间利用率
    averageTime: "02:42:12",//平均无故障时间
    stopNumber: "2",//停机次数
    shiftTime: "01:23:10",//班次时间
    stoptimeIn: "00:43:00",//停机持续时间 内部
    stoptimeOut: "00:12:00",//停机持续时间外部
    effect: "82%",//效率
    scrapRate: "19%",//废品率
    scrap: "3234",//废品
    OEE: "2321",//OEE
    OEE: "83%", //OEE
    MTBF: "26:13 min", //平均无故障时间
}

const Suite07_Shift0 = {
    equipment: "L07",//设备
    theorOutput: "45234",//理论的产量
    qualifYield: "24534",//合格的产量
    timeUtilization: "91%",//时间利用率
    averageTime: "04:43:12",//平均无故障时间
    stopNumber: "3",//停机次数
    shiftTime: "02:45:10",//班次时间
    stoptimeIn: "00:23:00",//停机持续时间 内部
    stoptimeOut: "00:45:00",//停机持续时间外部
    effect: "87%",//效率
    scrapRate: "2%",//废品率
    scrap: "4535",//废品
    OEE: "2234",//OEE
    OEE: "86%", //OEE
    MTBF: "32:43 min", //平均无故障时间
}

const Suite07_Shift1 = {
    equipment: "L07",//设备
    theorOutput: "56345",//理论的产量
    qualifYield: "35654",//合格的产量
    timeUtilization: "73%",//时间利用率
    averageTime: "04:15:15",//平均无故障时间
    stopNumber: "1",//停机次数
    shiftTime: "03:15:10",//班次时间
    stoptimeIn: "00:43:00",//停机持续时间 内部
    stoptimeOut: "00:54:00",//停机持续时间外部
    effect: "88%",//效率
    scrapRate: "12%",//废品率
    scrap: "4533",//废品
    OEE: "2342",//OEE
    OEE: "67%", //OEE
    MTBF: "34:51 min", //平均无故障时间
}

export const data = [
    {
        ...Suite01_Shift0
    },
    {
        ...Suite01_Shift1
    },
    {
        ...Suite02_Shift0
    },
    {
        ...Suite02_Shift1
    },
    {
        ...Suite03_Shift0
    },
    {
        ...Suite03_Shift1
    },
    {
        ...Suite04_Shift0
    },
    {
        ...Suite04_Shift1
    },
    {
        ...Suite05_Shift0
    },
    {
        ...Suite05_Shift1
    },
    {
        ...Suite06_Shift0
    },
    {
        ...Suite06_Shift1
    },
    {
        ...Suite07_Shift0
    },
    {
        ...Suite07_Shift1
    },
];